// src/routes/RequireRole.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireRole({ allow, children, fallback = "/player" }) {
  const role = localStorage.getItem("beercard_role");
  const location = useLocation();

  if (!role) return <Navigate to="/login" replace state={{ from: location }} />;

  return allow.includes(role)
    ? children
    : <Navigate to={fallback} replace />;
}